var r={silentJSONParsing:!0,forcedJSONParsing:!0,clarifyTimeoutError:!1};export{r as default};
//# sourceMappingURL=transitional.js.map
